import React from 'react';
import {Helmet} from 'react-helmet';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const NotFound = () => {
	return (
		<section className='not-found'>
			<Helmet>
				<title>404 Not Found | {process.env.REACT_APP_TITLE}</title>
			</Helmet>

			<Paper className='paper'>
				<Typography variant='h1'>404 Not Found</Typography>
			</Paper>
		</section>
	);
};

export default NotFound;
